import { Component, Inject, OnInit, OnDestroy, Input } from '@angular/core';

import { AuthService } from '@auth0/auth0-angular';
import { filter } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { TranslationService } from '../change-company/services/translation.service';

@Component({
  selector: 'zui-sidenav-login-button',
  templateUrl: './sidenav-login-button.component.html',
  styleUrls: ['./sidenav-login-button.component.scss']
})
export class SideNavLoginButtonComponent implements OnInit, OnDestroy {
  @Input() isMenuItem?: boolean;
  @Input() isExpanded?: boolean;
  private translated;
  public isLoggedIn: boolean;
  public label: string;

  constructor(
    public auth: AuthService,
    private translationService: TranslationService,
    @Inject('logoutReturnToUrl') private readonly logoutReturnToUrl: string
  ) {
    this.translated = this.translationService.getTranslation().userMenu;
  }

  private onDestroy$ = new Subject<void>();

  ngOnInit(): void {
    this.isLoggedIn = false;
    this.label = this.translated.login;

    this.auth.user$.pipe(filter(profile => profile != null)).subscribe(_ => {
      this.isLoggedIn = true;
      this.label = this.translated.logout;
    });
  }

  clickHandler(): void {
    this.isLoggedIn ? this.auth.logout({ returnTo: this.logoutReturnToUrl }) : this.auth.loginWithRedirect();
  }

  ngOnDestroy() {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }
}
